









import { Component, Vue } from "vue-property-decorator";
import pusher from "@/libs/pusher";
import { PusherMessages } from "./api/message-api";
import { Channel } from "pusher-js";
import NotificationToast from "./common/ui/components/NotificationToast.vue";

@Component({
  components: {
    NotificationToast
  }
})
export default class App extends Vue {
  channel!: Channel;

  get onMobile() {
    if (!this.$store.state.onMobile) return "";
    return "on-mobile h-100";
  }

  get serviceId() {
    return this.$store.state.service.id;
  }

  mounted() {
    this.subscribeToPusher();
  }

  subscribeToPusher() {
    this.channel = pusher.subscribe(`service-${this.serviceId}`);

    this.channel.bind("message.sent", (data: PusherMessages) => {
      const user = this.$store.state.user;
      const userId = user.userId;
      const staffId = user.staffId;

      if (userId === data.userId) return;

      const listUnReadMessage = this.$store.getters.getUnreadMessages;
      const projectId = Number(data.projectId);
      const project = listUnReadMessage[projectId];

      if (project == undefined) return;

      const isMentioned = data.staffIdsMentions.includes(staffId);

      this.$store.dispatch("updateCountUnReadMessage", {
        projectId,
        count: isMentioned ? project.count + 1 : project.count,
        hasUntaggedUnreadMessages: !isMentioned
      });

      if (isMentioned) {
        (this.$refs.notification as NotificationToast).showToast({
          message: data.username + "さんからのメッセージがあります。"
        });
      }
    });
  }
}
